<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleClien" :value="data.orderNo" placeholder="请选择"
            >
    <el-option :label="item.value" :value="item.value" v-for="(item,index) in options" :key="index"></el-option>
  </el-select>
</template>

<script>
    import { loadAllOrder } from "@/services/deviceOrder";

    export default {
        name: 'Operator',
        props: {
            value: {},
            moduleModel:{type:String},
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            },
            falseEdit:{
                type: Boolean,
                default: true
            },
            model: {type:String},

            hardwareVersion: {type:String},
            state: {
                type: Number,
                default: 1
            },
            excludeChanging: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {data: {}, options: [],allData:[]}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            },
            moduleModel:{
                immediate:true,
                handler(value){
                   this.options=[]

                    if (value) {
                        this.loadData(value);
                        if(this.falseEdit){
                           this.data={}
                           this.$emit("find", {});
                        }

                    }

                }
            },
            state(){
                this.reloadOrders()
            },
            excludeChanging(){
                this.reloadOrders()
            }

        },

        methods: {
            handleClien(value){
                let find= this.allData.find((item)=>{
                    return item.orderNo==value
                    })

                    let client={}
                    if (!find) {
                        client = {};
                    }

                    if (find==undefined) {
                        client = "";
                    }
                    if(find){
                        client={value:find.clientId,name:find.clientName }
                    }

                    this.$emit("input", {...find});
                    this.$emit("change", {...find});
                    this.$emit("find", {...client});
                    this.data = {...find};
            },


            async loadData(moduleModel) {
                if(moduleModel){
                    // 订单下拉支持按订单状态和主订单变更状态过滤，避免业务页拿到不可用订单。
                     const res =await loadAllOrder({moduleModel,model:this.model,hardwareVersion:this.hardwareVersion,state:this.state,excludeChanging:this.excludeChanging})
                    if(res&&res.code==0){
                        this.allData=res.data.list
                        this.options=res.data.list.map((item)=>{
                            return {value:item.orderNo}
                      })
                    }
                }

            },
            reloadOrders(){
                this.options=[]
                if(this.moduleModel){
                    this.loadData(this.moduleModel)
                }
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/orderNumber.vue